// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MembershipRouteImport } from './routes/membership'
import { Route as MyBookingsRouteImport } from './routes/my-bookings'
import { Route as StaffRouteImport } from './routes/staff'
import { Route as BookTeeTimeIdRouteImport } from './routes/book.$teeTimeId'
import { Route as MyBookingsIndexRouteImport } from './routes/my-bookings.index'
import { Route as MyBookingsBookingIdRouteImport } from './routes/my-bookings.$bookingId'
import { Route as StaffIndexRouteImport } from './routes/staff.index'
import { Route as StaffBookingsRouteImport } from './routes/staff.bookings'
import { Route as StaffCourseRouteImport } from './routes/staff.course'
import { Route as StaffCustomersRouteImport } from './routes/staff.customers'
import { Route as StaffPaymentsRouteImport } from './routes/staff.payments'
import { Route as StaffProShopRouteImport } from './routes/staff.pro-shop'
import { Route as StaffTeeSheetRouteImport } from './routes/staff.tee-sheet'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const DemoRoute = DemoRouteImport.update({
            id: '/demo',path: '/demo',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const MembershipRoute = MembershipRouteImport.update({
            id: '/membership',path: '/membership',getParentRoute: () => rootRouteImport
          })
const MyBookingsRoute = MyBookingsRouteImport.update({
            id: '/my-bookings',path: '/my-bookings',getParentRoute: () => rootRouteImport
          })
const StaffRoute = StaffRouteImport.update({
            id: '/staff',path: '/staff',getParentRoute: () => rootRouteImport
          })
const BookTeeTimeIdRoute = BookTeeTimeIdRouteImport.update({
            id: '/book/$teeTimeId',path: '/book/$teeTimeId',getParentRoute: () => rootRouteImport
          })
const MyBookingsIndexRoute = MyBookingsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MyBookingsRoute
          })
const MyBookingsBookingIdRoute = MyBookingsBookingIdRouteImport.update({
            id: '/$bookingId',path: '/$bookingId',getParentRoute: () => MyBookingsRoute
          })
const StaffIndexRoute = StaffIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => StaffRoute
          })
const StaffBookingsRoute = StaffBookingsRouteImport.update({
            id: '/bookings',path: '/bookings',getParentRoute: () => StaffRoute
          })
const StaffCourseRoute = StaffCourseRouteImport.update({
            id: '/course',path: '/course',getParentRoute: () => StaffRoute
          })
const StaffCustomersRoute = StaffCustomersRouteImport.update({
            id: '/customers',path: '/customers',getParentRoute: () => StaffRoute
          })
const StaffPaymentsRoute = StaffPaymentsRouteImport.update({
            id: '/payments',path: '/payments',getParentRoute: () => StaffRoute
          })
const StaffProShopRoute = StaffProShopRouteImport.update({
            id: '/pro-shop',path: '/pro-shop',getParentRoute: () => StaffRoute
          })
const StaffTeeSheetRoute = StaffTeeSheetRouteImport.update({
            id: '/tee-sheet',path: '/tee-sheet',getParentRoute: () => StaffRoute
          })





const MyBookingsRouteChildren = {
  MyBookingsBookingIdRoute: MyBookingsBookingIdRoute,MyBookingsIndexRoute: MyBookingsIndexRoute
}

const MyBookingsRouteWithChildren = MyBookingsRoute._addFileChildren(MyBookingsRouteChildren)




const StaffRouteChildren = {
  StaffBookingsRoute: StaffBookingsRoute,StaffCourseRoute: StaffCourseRoute,StaffCustomersRoute: StaffCustomersRoute,StaffPaymentsRoute: StaffPaymentsRoute,StaffProShopRoute: StaffProShopRoute,StaffTeeSheetRoute: StaffTeeSheetRoute,StaffIndexRoute: StaffIndexRoute
}

const StaffRouteWithChildren = StaffRoute._addFileChildren(StaffRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,DemoRoute: DemoRoute,LoginRoute: LoginRoute,MembershipRoute: MembershipRoute,MyBookingsRoute: MyBookingsRouteWithChildren,StaffRoute: StaffRouteWithChildren,BookTeeTimeIdRoute: BookTeeTimeIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)